export default __webpack_public_path__ + "static/icon-dropdown-articles-ded6633fe5fd3d8ba1b837a982847f12.svg";